import React from 'react';
import { Link } from 'react-router-dom';

interface FeatureLockProps {
  requiredTier: 'base' | 'premium' | 'pro';
  featureName?: string;
  size?: 'small' | 'medium';
}

const TIER_NAMES = {
  base: 'Base',
  premium: 'Premium',
  pro: 'Pro',
};

const TIER_COLORS = {
  base: '#4fd1c5',
  premium: '#d4af37',
  pro: '#9B59B6',
};

const FeatureLock: React.FC<FeatureLockProps> = ({ 
  requiredTier, 
  featureName, 
  size = 'medium' 
}) => {
  const tierName = TIER_NAMES[requiredTier];
  const tierColor = TIER_COLORS[requiredTier];

  if (size === 'small') {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        background: 'rgba(220, 53, 69, 0.1)',
        border: '1px solid rgba(220, 53, 69, 0.3)',
        borderRadius: '8px',
      }}>
        <span style={{ fontSize: '16px' }}>🔒</span>
        <span style={{ color: '#aaa', fontSize: '12px' }}>
          Доступно в{' '}
          <Link to="/subscription" style={{ 
            color: tierColor, 
            textDecoration: 'none',
            fontWeight: 600 
          }}>
            {tierName}
          </Link>
        </span>
      </div>
    );
  }

  return (
    <div style={{
      textAlign: 'center',
      padding: '32px 24px',
      background: 'linear-gradient(135deg, rgba(13, 25, 48, 0.8), rgba(30, 58, 95, 0.6))',
      border: '1px solid rgba(220, 53, 69, 0.3)',
      borderRadius: '16px',
    }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
      <h3 style={{ color: '#d4af37', fontSize: '20px', marginBottom: '8px' }}>
        Функция недоступна
      </h3>
      {featureName && (
        <p style={{ color: '#aaa', fontSize: '14px', marginBottom: '16px' }}>
          {featureName} доступно в подписке <strong style={{ color: tierColor }}>{tierName}</strong>
        </p>
      )}
      <Link to="/subscription">
        <button style={{
          padding: '12px 32px',
          borderRadius: '12px',
          border: 'none',
          background: 'linear-gradient(135deg, #d4af37, #b8941f)',
          color: '#0a0a1a',
          fontSize: '16px',
          fontWeight: 700,
          cursor: 'pointer',
        }}>
          Оформить подписку
        </button>
      </Link>
    </div>
  );
};

export default FeatureLock;
